export default "__VITE_ASSET__8c979a07__"